/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import { FontSize10, FontSize12, FontWeightNormal } from 'autogen/design-tokens/tokens';
import { breakpoint, sizes } from 'variables';

export const HeaderItemText = styled.span`
    display: none;

    ${breakpoint.up('768px')} {
        display: initial;
        font-size: ${FontSize10};
        font-weight: ${FontWeightNormal};
        white-space: nowrap;
    }

    ${breakpoint.up(sizes.lg)} {
        font-size: ${FontSize12};
    }
`;
